import styled, { css } from 'styled-components'
import Anchor from '@/ui/Anchor'
import StripedBG from '@/assets/images/striped-bg.png'

export const Wrapper = styled.div`
  padding: 0.5em;
  border: 2px dashed #b2c0c4;
  border-radius: 5px;
`

export const Background = styled.div`
  display: flex;
  align-items: center;
  height: 4em;
  position: relative;
  background: url(${StripedBG});
  border-radius: 4px;
  cursor: pointer;
`

export const Label = styled.strong`
  width: 100%;
  font-size: 16px;
  color: #597987;
  margin-left: 1em;
`

export const AddIcon = styled(Anchor)`
  ${({ theme }) => css`
    background: ${theme.primaryColor};
    min-width: 35px;
    width: 35px;
    height: 35px;
    border-radius: 4px;
    margin-right: 10px;

    i.icon {
      font-size: 30px !important;
      left: 0px;
    }
  `}
`
